import { A11CommerceConfig } from '@stocker/commerce-config'

// TODO: [AC-150] Create node.js script for generation A11CommerceConfig types
export function buildUrl (type: string, slug: string) {
  const prefix = A11CommerceConfig.urlBuilder.find((item) => item.type === type)

  return prefix?.path ? `/${prefix.path}/${slug}` : `${slug}`
}
